import { Routes } from "@angular/router";

export default [
  {
    path: "",
    loadComponent: () => import("./iframe-driftstatus.component")
  }
] as Routes;
